module.exports = __webpack_public_path__ + "img/sec4_06.22e234dc.png";